import {
  TrackPayMethodParamsInterface,
  TrackPayMethodPayloadInterface,
  GlobalAnalyticsVariablesInterface
} from '../interfaces';
import {analyticsConstants} from '../../constants';
import {TelemetryGenericEnum} from '../../shared/enums';
import {retrieveMergeResponseGlobalVarsCase} from './retrieve-merge-response-global-vars.case';

export const trackPayMethodPayloadCase = (
  payload: TrackPayMethodParamsInterface,
  globalVariables?: GlobalAnalyticsVariablesInterface,
): TrackPayMethodPayloadInterface => {
  const data = retrieveTrackPayMethodPayload(payload);
  return retrieveMergeResponseGlobalVarsCase(true, data, globalVariables);
}

const retrieveTrackPayMethodPayload = (
  payload: TrackPayMethodParamsInterface
): TrackPayMethodPayloadInterface => ({
  eventType: TelemetryGenericEnum.INTERACTION_EVENT_TYPE,
  olciPassengerIds: payload.olciPassengerIds ?? TelemetryGenericEnum.EMPTY_VALUE,
  fluidVariable: analyticsConstants.ONBOARD_EXPENSES.PAY_METHOD.FLUID_VARIABLE,
  interaction: analyticsConstants.ONBOARD_EXPENSES.PAY_METHOD.INTERACTION,
  pageName: analyticsConstants.ONBOARD_EXPENSES.PAY_METHOD.PAGE_NAME,
  paymentMethod: payload.paymentMethod,
})
